export default __webpack_public_path__ + "logoLi.png";